{
    "roadmap": {
        "common": {
            "openAll": "Open alles",
            "closeAll": "Sluit alles",
            "openorCloseTitle": "Open/Sluit Alle accordeon"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Wat is NextGen IT: Breng IT-automatisering naar de eindgebruiker en los het probleem sneller op.",
            "acc1Title": "In Productie",
            "prodItem1": "KB Artikel integratie: 300+ KB artikelen die IT zelfoplossing mogelijk maken",
            "prodItem2": "Zelfherstellende oplossing: Meer dan 18 externe scripts zijn beschikbaar om het probleem op te lossen.",
            "prodItem3": "Incidentcreatie: Zorgt voor nauwkeurige en snellere oplossing door geautomatiseerde incidentregistratie.",
            "prodItem4": "Chat met Live agent (menselijke agent): MyHelp stelt gebruikers in staat om te chatten met een menselijke agent vanuit AI Assistant",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Plan terugbelafspraak (Feb - 2026): Plan een IT-ondersteuning terugbelafspraak op een tijd die past bij uw beschikbaarheid",
            "devItem2": "Intelligente routering (Feb - 2026): Routeer tickets naar het juiste oplosteam voor snellere ondersteuning",
            "acc3Title": "Backlog",
            "backItem1": "PKI probleemoplossingsagent: MyHelp integratie met de PKI probleemoplossingsagent om certificaatgerelateerde problemen aan te pakken",
            "backItem2": "Plan afspraken bij het Walk‑in Center direct via MyHelp"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "De Corporate is verantwoordelijk voor het beheren van bedrijfsapplicaties, HR-platforms, die de ondersteuning van personeel en bedrijfsfuncties bieden.",
            "acc1Title": "In Productie",
            "prodItem1": "BU gebaseerde Apps: 90+ apps met BU-gebaseerde personalisatie",
            "prodItem2": "Aangepaste app vastpinnen: Gebruikers kunnen hun MyHelp-dashboard personaliseren door aangepaste apps vast te pinnen",
            "prodItem3": "Werkplekvragen: 100+ werkplekvragen (kantoor, parkeren, gebouwen)",
            "prodItem4": "Vergaderruimte boeken met AI-assistent: Snelle, vereenvoudigde vergaderruimte boeking met Gingco integratie",
            "prodItem5": "HR Vragen: MyHelp beantwoordt de top 50 HR vragen",
            "prodItem6": "Mensen Zoeken: Gebruikers kunnen hun E.ON collega's zoeken via MyHelp",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Applicatie onboarding gebaseerd op bedrijfsunit uitrol.",
            "devItem2": "Vergaderruimte AI-assistent",
            "acc3Title": "In Backlog",
            "backItem1": "Voeg apps toe vanuit AI-assistent en aangepaste Tabs: Voeg apps direct toe via de voorgestelde opties van MyHelp Assistant"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Deze integratie helpt u relevante trainingen en cursussen te vinden.",
            "acc1Title": "In Productie",
            "prodItem1": "Zoek trainingen & cursussen: Vind relevante trainingen en cursussen met behulp van MyHelp",
            "acc2Title": "In Ontwikkeling",
            "acc3Title": "In Backlog",
            "backItem1": "Persoonlijk leren: Persoonlijke trainingsaanbevelingen gebaseerd op bedrijfsunit geschiktheid."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "Deze integratie helpt u relevante IT-bestelitems en catalogi te vinden.",
            "acc1Title": "In Productie",
            "prodItem1": "Snelle IT-bestelcatalogus zoekopdracht: Snel zoeken en uw IT bestellen via MyHelp",
            "prodItem2": "Softwaretoegang inschakelen & intrekken: Schakel softwaretoegang in of trek deze in door te navigeren vanuit MyHelp.",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "IT-assets kostenoverzicht: MyHelp zal een kostenoverzicht van uw IT-assets weergeven",
            "acc3Title": "In Backlog",
            "backItem1": "Centrale goedkeuring van bestelde items"
        },
        "compass": {
            "title": "Compass",
            "desc": "Deze integratie helpt u gemeenschap, nieuws en aankondigingen te vinden die op het intranet worden gedeeld.",
            "acc1Title": "In Productie",
            "prodItem1": "Wordt vrijgegeven op 28 februari 2026",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Compass Zoekopdracht (Feb – 2026): E.ON-gebruikers kunnen hun gemeenschap gegevens zoeken in MyHelp E.ON Zoekopdracht",
            "devItem2": "MyHelp-Compass AI-assistent (in uitvoering) (Feb – 2026): E.ON-gebruikers toegang geven tot gemeenschap gegevens via de MyHelp AI-assistent",
            "acc3Title": "In Backlog"
        },
        "chatProjectData": {
            "title": "Chat met uw projectgegevens",
            "desc": "Deze integratie stelt u in staat uw projectgegevens van confluence, sharepoint etc. te onboarden.",
            "acc1Title": "In Productie",
            "prodItem1": "Confluence One Billing en DSODP projecten zijn onboard",
            "prodItem2": "SharePoint sites – DSODP projectsite is onboard",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Er wordt momenteel gewerkt aan het integreren van de Nautilus projectgegevens.",
            "acc3Title": "In Backlog"
        },
        "personalization": {
            "title": "Personalisatie",
            "acc1Title": "In Productie",
            "prodItem1": "Meertalig: ondersteunt 4 talen (Engels, Deutsch, Svenska, Română)",
            "prodItem2": "Multi-thema: stelt elke bedrijfsunit of regio in staat zijn eigen branding te gebruiken, wat de vertrouwdheid en adoptie verbetert.",
            "prodItem3": "5 extra nieuwe talen onder bètaprofiel (Čeština, Italiano, Magyar, Nederlands en Polski)",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Dataspecifiek: (15 februari – 2026): biedt meer gerichte en contextbewuste antwoorden door informatie te halen uit de door de gebruiker geselecteerde gegevensbronnen.",
            "acc3Title": "In Backlog"
        },
        "technicalEnablement": {
            "title": "Technische Inschakeling",
            "acc1Title": "In Productie",
            "prodItem1": "Beveiliging & Observeerbaarheid zorgen voor gegevensbescherming op ondernemingsniveau, naleving en prestaties, en maken ook een veilige, betrouwbare en soepele uitvoering van operaties mogelijk",
            "prodItem2": "KPI & adoptie dashboards (Power BI)<br /> Biedt duidelijk inzicht in gebruik, waarderealisatie en zakelijke impact via KPI dashboards",
            "acc2Title": "In Ontwikkeling",
            "devItem1": "Multiagent workflow tegen 15 maart 2026: Maakt meer intentiegedreven gesprekken mogelijk die niet alleen de relevantie van antwoorden verbeteren, maar ook end-to-end voor gebruikers uitvoeren.",
            "acc3Title": "In Backlog",
            "backItem1": "MCP framework (Backlog): <br /> Biedt een basis om AI-agenten binnen E.ON te orkestreren en coördineren, waardoor schaalbare en collaboratieve AI-capaciteiten voor ondernemingen mogelijk worden."
        }
    }
}